var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_2761_3718)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#062C5B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17C22.1046 17 23 16.1046 23 15C23 13.8954 22.1046 13 21 13C19.8954 13 19 13.8954 19 15C19 16.1046 19.8954 17 21 17Z",
    fill: "#4C7EBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17C16.1046 17 17 16.1046 17 15C17 13.8954 16.1046 13 15 13C13.8954 13 13 13.8954 13 15C13 16.1046 13.8954 17 15 17Z",
    fill: "#4C7EBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 17C28.1046 17 29 16.1046 29 15C29 13.8954 28.1046 13 27 13C25.8954 13 25 13.8954 25 15C25 16.1046 25.8954 17 27 17Z",
    fill: "#4C7EBD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 23C22.1046 23 23 22.1046 23 21C23 19.8954 22.1046 19 21 19C19.8954 19 19 19.8954 19 21C19 22.1046 19.8954 23 21 23Z",
    fill: "#4C7EBD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 23C16.1046 23 17 22.1046 17 21C17 19.8954 16.1046 19 15 19C13.8954 19 13 19.8954 13 21C13 22.1046 13.8954 23 15 23Z",
    fill: "#4C7EBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27 23C28.1046 23 29 22.1046 29 21C29 19.8954 28.1046 19 27 19C25.8954 19 25 19.8954 25 21C25 22.1046 25.8954 23 27 23Z",
    fill: "#4C7EBD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 29C22.1046 29 23 28.1046 23 27C23 25.8954 22.1046 25 21 25C19.8954 25 19 25.8954 19 27C19 28.1046 19.8954 29 21 29Z",
    fill: "#4C7EBD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_2761_3718",
    x: -4,
    y: -4,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2761_3718"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2761_3718",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup8);
export default __webpack_public_path__ + "static/media/Group8.36a8cfd508d7c64e84f687c73f43058d.svg";
export { ForwardRef as ReactComponent };